import React, { useEffect, useState } from "react";
import Loader from "../Loader/Loader";
import { message, Pagination } from "antd";
import { AiFillDelete, AiFillEdit, AiOutlineEye } from "react-icons/ai";
import {getLayouts, deleteLayout} from '../../Web Apis/Apis'
import defaultImg from '../../Images/no image.png'

import CreateLayout from "./CreateLayout";
import EditLayout from "./EditLayout";

function Layouts() {
  const [loading, setLoading] = useState(false);
  const [layout, setLayout] = useState([]);

  const [selectedLayout, setSelectedLayout] = useState({});
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [action, setAction] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);


  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Calculate the current items for the page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const CurrentValues = layout.slice(indexOfFirstItem, indexOfLastItem);

  const handleCreateModalOpen = () => {
    setShowCreateModal(true);
  };

  const handleDeleteModalOpen = (value) => {
    setSelectedLayout(value);
    setShowDeleteModal(true);
  };

  const handleUpdateModalOpen = (value) => {
    setSelectedLayout(value);
    setShowEditModal(true);
  };


  const fetchLayouts = async () => {
    try {
      setLoading(true)

      const response = await getLayouts()
      console.log("reeessss", response)
      if(response.data.success){
        const reverseData = response?.data?.data.reverse()
        setLayout(reverseData)
      }
      
    } catch (error) {
      console.log("Error found", error)
      if (error.message === 'Network Error' || error.message.includes('ERR_INTERNET_DISCONNECTED')) {
              // Handle internet disconnection
              return;
            }
            // Handle specific error cases
            if (error?.response?.status === 401) {
              window.alert("Your account is logged in to another device, please login again !")
              localStorage.clear();
              window.location.href = "/login"
            }
            if (error?.response?.status === 500) {
              message.error("Server not responding")
            }
          } finally {
            setLoading(false)
          }
  }

  useEffect(() => {
    fetchLayouts()
  }, [action])


const deleteThisLayout = async () => {
  try {
    setLoading(true)

    const response = await deleteLayout(selectedLayout?.id)
    if(response?.data?.success){
      message.success(response?.data?.message)
      setShowDeleteModal(false)
      setAction(!action)
    }
  } catch (error) {
    console.log("Error while delete layout", error)
    message.error(error?.response?.data?.message || "Error while delete layout")
  } finally {
    setLoading(false)
  }
}

  return (
    <div className="p-4">
      <div className="flex justify-between">
        <h3 className="text-3xl font-bold">Predefined Layouts</h3>
        <div className="flex justify-end">
          <button
            onClick={handleCreateModalOpen}
            className="bg-gradient-to-br from-blue-500 to-gray-500 hover:bg-blue-700 text-white font-bold py-2 px-8 rounded"
          >
            Create
          </button>
        </div>
      </div>
      <table className="min-w-full mt-7 bg-gradient-to-br from-purple-700 to-gray-300 border border-b-4 border-black">
        <thead>
          <tr>
             <th className="py-2 px-4 border-b text-center">S.No</th>
          <th className="py-2 px-4 border-b text-center">Layout Name</th>
          <th className="py-2 px-4 border-b text-center">Layout Image</th>
          <th className="py-2 px-4 border-b text-center">Actions</th>
          </tr>
        </thead>
      <tbody>
      {CurrentValues?.length > 0 ? (
            CurrentValues?.map((item, index) => (
                <tr key={item.id}
                className={`hover:bg-gray-200 text-center transition duration-200 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-300'}`}
                >
                  <td className='py-2 px-4 border-b'>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                  <td className="py-2 px-4 border-b">{item.draftVoucherName}</td>
                  <td className="py-2 px-4 border-b flex justify-center">
                     <img
                        src={item.previewImage || defaultImg }
                        alt="category"
                        className="w-32 h-28 object-cover border border-gray-700 rounded-full"
                        // style={{ height: "60px", width: "60px", borderRadius: "50%" }}
                        />
                  </td>

                 <td className="py-2 px-4 border-b ">
                                                      <div className="flex flex-row justify-center ">
                                                      
                                                         <button
                                                           onClick={() => handleUpdateModalOpen(item)}
                                                           className="mr-2 text-blue-500 hover:text-blue-700 flex items-center"
                                                         >
                                                           <AiFillEdit className="mr-1 text-2xl" />
                                                        </button> 
                                                        <button
                                                          onClick={() => handleDeleteModalOpen(item)}
                                                          className="text-red-500 hover:text-red-700 flex items-center"
                                                        >
                                                          <AiFillDelete className="mr-1 text-2xl" />
                                                        </button>
                                                      </div>
                                                    </td>


                </tr>
                   ))
        ) : (
            <tr>
            <td colSpan="7" className=' px-4 py-4 border-b text-center font-bold'>No predefined layouts data found</td>
          </tr>
        )}
      </tbody>
      </table>
      {loading && <Loader/>}


      {showCreateModal && (
        <CreateLayout
        showModal={showCreateModal}
        setShowModal={setShowCreateModal}
        action={action}
        setAction={setAction}
        />
      )}

      {showEditModal && (
        <EditLayout
        showModal={showEditModal}
        setShowModal={setShowEditModal}
        selectedItem={selectedLayout}
        action={action}
        setAction={setAction}
        />
      )}

      {showDeleteModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-gradient-to-br from-purple-900 to-purple-500 p-8 rounded-lg shadow-lg w-full max-w-md">
            <h3 className="text-3xl font-bold mb-4 text-start text-white">Confirm Delete</h3>
            <p className="mb-4 text-start text-white">Are you sure you want to delete this layout ? </p>
            <div className="flex justify-end gap-4">
              {console.log("id", selectedLayout)}
              <button onClick={() => { setShowDeleteModal(false) }} className="bg-gray-300 text-black py-3 px-8 rounded-md hover:bg-gray-400 transition duration-200">
                Cancel
              </button>
              <button onClick={deleteThisLayout} className="bg-red-600 text-white py-3 px-8 rounded-md mr-2 hover:bg-red-700 transition duration-200">
                Delete
              </button>
            </div>
          </div>
        </div>
      )
      }
    </div>
  );
}

export default Layouts;
